import { useEffect, useState } from 'react';
import axios from 'axios';
import { Users, CreditCard, TrendingUp, UserPlus } from 'lucide-react';
import { DashboardLayout } from '../components/layout/DashboardLayout';
import { Header } from '../components/layout/Header';
import { StatCard } from '../components/dashboard/StatCard';
import { RevenueChart } from '../components/dashboard/RevenueChart';
import { RecentActivity } from '../components/dashboard/RecentActivity';
import { MemberTable } from '../components/dashboard/MemberTable';

const API = `${process.env.REACT_APP_BACKEND_URL || "http://localhost:8000"}/api`;

export default function Dashboard() {
  const [stats, setStats] = useState({
    total_members: 0,
    active_plans: 0,
    revenue_this_month: 0,
    new_signups: 0
  });
  const [revenueData, setRevenueData] = useState([]);
  const [members, setMembers] = useState([]);
  const [checkins, setCheckins] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const [statsRes, revenueRes, membersRes, checkinsRes] = await Promise.all([
        axios.get(`${API}/dashboard/stats`, { withCredentials: true }),
        axios.get(`${API}/dashboard/revenue-chart`, { withCredentials: true }),
        axios.get(`${API}/members`, { withCredentials: true }),
        axios.get(`${API}/checkins/recent`, { withCredentials: true })
      ]);
      
      setStats(statsRes.data);
      setRevenueData(revenueRes.data);
      setMembers(membersRes.data);
      setCheckins(checkinsRes.data);
    } catch (error) {
      console.error('Failed to fetch dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <DashboardLayout>
        <Header title="Dashboard" />
        <div className="p-8 flex items-center justify-center min-h-[calc(100vh-4rem)]">
          <div className="w-8 h-8 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin" />
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <Header title="Dashboard" />
      <div className="p-8" data-testid="dashboard-page">
        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <StatCard
            title="Total Members"
            value={stats.total_members.toLocaleString('id-ID')}
            icon={Users}
            color="primary"
            trend="up"
            trendValue="+12% dari bulan lalu"
          />
          <StatCard
            title="Active Plans"
            value={stats.active_plans.toLocaleString('id-ID')}
            icon={TrendingUp}
            trend="up"
            trendValue="+8% dari bulan lalu"
          />
          <StatCard
            title="Revenue Bulan Ini"
            value={`Rp ${Math.round(stats.revenue_this_month).toLocaleString('id-ID')}`}
            icon={CreditCard}
            trend="up"
            trendValue="+15% dari bulan lalu"
          />
          <StatCard
            title="New Signups"
            value={`+${stats.new_signups}`}
            icon={UserPlus}
            color="primary"
            trend="up"
            trendValue="minggu ini"
          />
        </div>

        {/* Chart and Activity Row */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 items-start mb-8">
          <div className="lg:col-span-3">
            <RevenueChart data={revenueData} />
          </div>
          <div className="lg:col-span-1">
            <RecentActivity checkins={checkins} />
          </div>
        </div>

        {/* Member Table */}
        <MemberTable members={members} limit={5} />
      </div>
    </DashboardLayout>
  );
}

